// global.img_url = 'http://localhost/zaimah-tech-website/ztl-server/public';
//  global.img_url ='https://dev.zaimahtech.com/ztl-server/public';
global.img_url = 'https://zaimahtech.com/ztl-server/public';